import { useEffect, useState } from 'react';
import { History, RotateCcw } from 'lucide-react';
import { historyStore, type FrameVersionMeta } from '../../history/historyStore';
import { useCanvasStore } from '../../store/canvas-store';

export function FrameHistorySection({ frameId }: { frameId: string }) {
  const [versions, setVersions] = useState<FrameVersionMeta[]>([]);

  const refresh = () => { void historyStore.listFrameVersions(frameId).then(setVersions); };

  useEffect(() => {
    let alive = true;
    void historyStore.listFrameVersions(frameId).then((v) => { if (alive) setVersions(v); });
    return () => { alive = false; };
  }, [frameId]);

  async function restore(key: number) {
    const frame = await historyStore.getFrameVersion(key);
    if (frame) useCanvasStore.getState().dispatch({ t: 'frame.restore', frame });
    // Reflect the restore immediately, then again after the debounced re-capture.
    void refresh();
    setTimeout(() => { void refresh(); }, 1800);
  }

  if (versions.length === 0) return null;

  return (
    <div className="px-3 py-2 border-t border-[var(--color-border)]">
      <div className="flex items-center gap-1.5 text-[11px] font-sans text-[var(--color-text-muted)] mb-1">
        <History size={12} />
        History
      </div>
      <ul className="flex flex-col gap-0.5 max-h-40 overflow-auto">
        {versions.map((v) => (
          <li key={v.key} className="flex items-center justify-between text-[11px] font-mono">
            <span className="text-[var(--color-text-muted)] truncate">
              {new Date(v.ts).toLocaleTimeString()}{v.label ? ` — ${v.label}` : ''}
            </span>
            <button
              type="button"
              className="flex items-center gap-1 text-[var(--color-text-muted)] hover:text-[var(--color-accent)] shrink-0 ml-2"
              onClick={() => { void restore(v.key); }}
              title="Restore this version"
            >
              <RotateCcw size={12} />
              Restore
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
